module.exports = __webpack_public_path__ + "static/media/speed.c6c011b3.svg";